import ConfirmDialog, { ConfirmDialogProps } from "@components/ConfirmDialog"
import { AppNode, NodeType } from "@features/builder/graph/types"
import { Alert, Grid, List, ListItem, ListItemText, Typography } from "@mui/material"

type ConfirmDeletingNodesDialogProps = Pick<ConfirmDialogProps, "onClose"> & {
  nodes: AppNode[]
}

const ConfirmDeletingNodesDialog = (props: ConfirmDeletingNodesDialogProps) => {
  const hasGroup = props.nodes.some((node) => node.type === NodeType.Group)

  return (
    <ConfirmDialog dialogTitle="Confirm deleting nodes" open onClose={props.onClose}>
      <Grid container direction="column" gap={2}>
        {hasGroup && (
          <Grid item>
            <Alert severity="warning">
              You are about to delete group node. <br />
              That means that every node within the group will be also deleted.
            </Alert>
          </Grid>
        )}

        <Grid item>
          <Typography>
            Are you sure you want to delete nodes listed below? <br />
            This action is irreversible.
          </Typography>
        </Grid>

        <Grid item>
          <List dense>
            {props.nodes.map((node) => (
              <ListItem key={node.id}>
                <ListItemText primary={`- ${node.data.label}`} />
              </ListItem>
            ))}
          </List>
        </Grid>
      </Grid>
    </ConfirmDialog>
  )
}

export default ConfirmDeletingNodesDialog
